export const mobileRadius = 172;

export const mobileDiameter = mobileRadius * 2;

export const desktopRadius = 290;

export const desktopDiameter = desktopRadius * 2;

export const noRotationElementsClass = 'no_rotation_elements';
export const rotationElementsClass = 'rotation_elements';

export const outerShadowElementsClass = 'outerShadowElement';
export const decorativeElementsClass = 'decorativeElements';
export const wheelBorderClass = 'wheel_border_class';
export const rotationWheelClass = 'rotation_wheel_class';
export const rotationAnimationName = 'wheel_rotation_animation';

export const winArrowContainerClass = 'winArrowContainer';
export const winArrowClass = 'winArrow';

